import { styled } from '@mui/material/styles'
import { default as IconButtonBase } from '@mui/material/IconButton'

export const IconButton = styled(IconButtonBase, {
  name: 'DirectBilling',
  slot: 'IconButton',
})(({ theme }) => ({
  fontSize: theme.typography.body2.fontSize,
  color: theme.palette.custom.blue,
  padding: 0,
  pointerEvents: 'auto',
  '&:hover': {
    backgroundColor: 'transparent',
  },
}))
